import { render, staticRenderFns } from "./ArgusStatistic.vue?vue&type=template&id=22142ff2&"
import script from "./ArgusStatistic.vue?vue&type=script&lang=js&"
export * from "./ArgusStatistic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports